import { render, staticRenderFns } from "./CalendarSharingSettings.vue?vue&type=template&id=0d83ed8c"
import script from "./CalendarSharingSettings.vue?vue&type=script&lang=js"
export * from "./CalendarSharingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports